export enum ActionType {
    Block,
    Out,
    Utility,
    WriteOff
}